// extracted by mini-css-extract-plugin
export default {"label":"Label_label__DUfkj","error":"Label_error__LjY86","required":"Label_required__mm5S1","capitalize":"Label_capitalize__dyaWY","small":"Label_small__vj1ca"};